
import React from "react";
import Box from "@mui/material/Box";

const AdminstrationPage = () => {
	return (
		<Box sx={{ mt: 1 }}>
			<h2>لوحة الإدارة</h2>
		</Box>
	);
};

export default AdminstrationPage;
